/**
 * fca-ship-bar.js — Filaments.ca shipping milestone bar
 * Loaded as a theme asset so it's always registered, even when sections
 * are re-rendered by Shopify's section rendering API.
 *
 * Pricing:
 *   < $100  → $10 flat rate shipping
 *   $100+   → FREE shipping
 */

(function () {
  const THRESHOLD = 10000; // $100 in cents

  function fmt(cents) {
    const val = cents / 100;
    return '$' + (Number.isInteger(val) ? val : val.toFixed(2));
  }

  function updateBar(el, totalCents) {
    const msg     = el.querySelector('.fca-ship-bar__msg');
    const markers = el.querySelectorAll('.fca-ship-bar__marker');
    if (!msg) return;
    msg.style.fontSize = '1.1rem';

    let pct, msgHTML;

    pct = Math.min(Math.round(totalCents / THRESHOLD * 100), 100);

    if (totalCents >= THRESHOLD) {
      msgHTML = '🎉 <strong>You\'ve unlocked FREE shipping!</strong>';
    } else {
      msgHTML = `Spend <strong>${fmt(THRESHOLD - totalCents)}</strong> more for <strong>FREE shipping</strong> &nbsp;·&nbsp; <strong style="color:#1a6e30;">Orders under $100 ship for $10</strong>`;
    }

    const fill = el.querySelector('.fca-ship-bar__fill');
    if (fill) {
      fill.style.cssText = `display:block; height:8px; width:${pct}%; max-width:100%; background-color:#1a6e30; border-radius:4px; transition:width 0.4s ease;`;
    }
    msg.innerHTML = msgHTML;

    // Update single marker colour inline
    markers.forEach((m) => {
      if (!m) return;
      const reached = totalCents >= THRESHOLD;
      m.style.backgroundColor = reached ? '#1a6e30' : '#ccc';
      m.style.boxShadow = `0 0 0 1px ${reached ? '#1a6e30' : '#ccc'}`;
      const label = m.querySelector('span');
      if (label) {
        label.style.color = reached ? '#1a6e30' : '#555';
        label.style.fontSize = '0.85rem';
      }
    });
  }

  function initAllBars(totalCents) {
    document.querySelectorAll('.fca-ship-bar').forEach(el => {
      updateBar(el, totalCents);
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => initAllBars(cart.total_price))
      .catch(() => {});
  }

  // Init from server-rendered data-cart-total on page load
  function initFromDOM() {
    document.querySelectorAll('.fca-ship-bar').forEach(el => {
      const total = parseInt(el.dataset.cartTotal, 10);
      if (!isNaN(total)) updateBar(el, total);
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromDOM);
  } else {
    initFromDOM();
  }

  // Re-init when Shopify re-renders sections (cart drawer, etc.)
  document.addEventListener('shopify:section:load', initFromDOM);

  // Re-init after cart quantity changes
  document.addEventListener('afterCartChanged', fetchCartAndUpdate);
  document.addEventListener('afterUpdateQuantity', fetchCartAndUpdate);

  // Also watch for DOM mutations in case the section HTML is swapped
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.fca-ship-bar:not([data-initialized])').forEach(el => {
      el.setAttribute('data-initialized', '1');
      const total = parseInt(el.dataset.cartTotal, 10);
      if (!isNaN(total)) updateBar(el, total);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
